import api from '../config/api';
import { API_ENDPOINTS } from '../config/constants';

export const cartService = {
  getCart: async () => {
    const response = await api.get(API_ENDPOINTS.CART.GET);
    return response.data;
  },

  addToCart: async (product_id, quantity = 1) => {
    const response = await api.post(API_ENDPOINTS.CART.ADD, {
      product_id,
      quantity,
    });
    return response.data;
  },

  updateCartItem: async (cartItemId, quantity) => {
    const response = await api.put(API_ENDPOINTS.CART.UPDATE(cartItemId), {
      quantity,
    });
    return response.data;
  },

  removeFromCart: async (cartItemId) => {
    const response = await api.delete(API_ENDPOINTS.CART.DELETE(cartItemId));
    return response.data;
  },

  clearCart: async () => {
    const response = await api.delete(API_ENDPOINTS.CART.CLEAR);
    return response.data;
  },

  validateCart: async () => {
    const response = await api.get(API_ENDPOINTS.CART.VALIDATE);
    return response.data;
  },
};

export default cartService;